import {Component, OnDestroy, OnInit} from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { LabOrderBusinessService } from '../shared/lab-order-business.service';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import { UtilsService } from '../shared/utils.service';
import { SubscriptionsContainer } from '../shared/subscriptions-container';
import {DataConstants} from '../shared/data/data-constants';
import { ApiError } from '../shared/data/api-error';
import { Messages } from '../shared/messages';
import { ClearMessagesService } from '../shared/clear-messages.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit, OnDestroy {

  labOrderForm: FormGroup;
  data: any;
  message: any;
  subs = new SubscriptionsContainer();

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private labOrderBusinessService: LabOrderBusinessService,
    private clearMessagesService: ClearMessagesService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.labOrderForm = this.formBuilder.group( {
      labOrderNumber: '',
      labInvoiceNumber: '',
      selectedAction: ''
    });
    this.subs.add = this.route.params.subscribe(params => {
      this.message = params['message'];
      if (this.message) {
        console.log('got message from route parameters', this.message);
      }
    });

    // clear old status message
    this.subs.add = this.clearMessagesService.getClearMessages().subscribe(
      (clearMessage) => {
        if (clearMessage) {
          this.message = '';
        }
      }
    );
  }
  ngOnDestroy(): void {
    console.log(' Orders Component - ngOnDestroy ' );
    this.subs.dispose();
  }

  // This method accepts the request event and delegates to the appropriate handler method.
  public submit(action) {

    // check order number was entered on form.
    if (UtilsService.isEmptyOrZero(this.labOrderForm.value.labOrderNumber)) {
      alert('Please enter order number.');
      return;
    }

    switch (action) {
      case 'ACCEPT' : this.acceptOrder(); break;
      case 'VIEW' : this.viewOrder(); break;
      case 'ASSIGN' : this.assignInvoiceNumber(); break;
      case 'COMPLETE' : this.completeOrder(); break;
      case 'MODIFY' : this.modifyOrder(); break;
      case 'VOID' : this.voidOrder(); break;

      default : console.log('Unknown submission.'); break;
    }
  }

  // This method will assign invoice number to the lab order.
  public assignInvoiceNumber() {
    console.log('Assign Invoice Number: ' + this.labOrderForm.value.labInvoiceNumber);


    const labInvoiceNumber = this.labOrderForm.value.labInvoiceNumber;
    const labOrderNumber = this.labOrderForm.value.labOrderNumber;

    // if invoice number is specified, let's make sure it's not more than 11 chars.
    if (labInvoiceNumber && labInvoiceNumber.length > 11) {
      alert('Invoice number should be 11 characters or less.');
      return;
    }

    this.subs.add = this.labOrderBusinessService.assignInvoiceNumber(labOrderNumber, labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          console.log('Successfully assigned invoice number: ' + labInvoiceNumber + ' to order number ' + labOrderNumber);
          this.data = labOrder;
          this.labOrderForm.reset();
          alert('Successfully assigned invoice number');
        },
        (httpError) => {
          this.data = null;
          //default error message to user
          let errorMessage: string = 'Error accessing order \'' + labOrderNumber + '\'';

          // display error to console if anything returned
          if (httpError) {
            console.error('httpCode=' + httpError.status + ' httpStatus=' + httpError.statusText);

            if (httpError.error) {
              const errors: ApiError[] = <ApiError[]> httpError.error;
              for (let i = 0; i < errors.length; i++) {
                const error: ApiError = errors[i];
                if (error) {
                  if (error.code === DataConstants.LABVAL_CODE_STATUS_INVALID) {
                    errorMessage = 'Cannot update order \'' + labOrderNumber + '\' in this status';
                  }
                  // give details to console error.
                  console.error('ApiError code: \'' + error.code + '\' message: \'' + error.message + '\'');
                }
              }
            }
          }
          console.error(errorMessage);
          alert(errorMessage);
        }
      );
  }

  // This method will View the order.
  public viewOrder() {
    console.log('View order: ' + this.labOrderForm.value.labOrderNumber);
    const labOrderNumber = this.labOrderForm.value.labOrderNumber;

    this.subs.add = this.labOrderBusinessService.viewLabOrder(labOrderNumber)
      .subscribe(
        (labOrder) => {
          console.log('Successfully viewed order: ' + labOrderNumber);

          this.data = labOrder;
          this.router.navigate(['viewOrder/', labOrderNumber ]);
        },
        (error) => {
          this.data = null;
          console.error('Unable to view order \'' + labOrderNumber + '\': ' + error.message);
          alert('Unable to lookup order \'' + labOrderNumber + '\'.');
        }
      );
  }

  // This method will Accept the order.
  public acceptOrder() {
    const labOrderNumber: string = this.labOrderForm.value.labOrderNumber;
    const labInvoiceNumber: string = this.labOrderForm.value.labInvoiceNumber;

    console.log('Accept request received for: ' + labOrderNumber);
    console.log('Assign Invoice Number: ' + labInvoiceNumber);

    // if invoice number is specified, let's make sure it's not more than 11 chars.
    if (labInvoiceNumber && labInvoiceNumber.length > DataConstants.INVOICE_NUMBER_LENGHT) {
      alert('Invoice number should be ' + DataConstants.INVOICE_NUMBER_LENGHT + ' characters or less.');
      return;
    }

    this.subs.add = this.labOrderBusinessService.acceptLabOrder(this.labOrderForm.value.labOrderNumber, labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          const message = 'Successfully accepted order: ' + labOrder.labOrderNumber;
          console.log(message);
          this.data = labOrder;
          this.message = message;
          this.labOrderForm.reset();
          alert('Successfully accepted labOrder');
        },
        (error) => {
          this.data = null;
          this.message = error.message;
          console.error('Error accepting order: ' + error.message);
          alert('Error accepting labOrder. ' + error.message);
        }
      );
  }

  // This method will Void the order.
  public voidOrder() {
    console.log('Void order: ' + this.labOrderForm.value.labOrderNumber);

    this.subs.add = this.labOrderBusinessService
      .voidLabOrder(this.labOrderForm.value.labOrderNumber, this.labOrderForm.value.labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          const message = 'Successfully voided order: ' +  labOrder.labOrderNumber;
          console.log(message);
          this.data = labOrder;
          this.message = message;
          this.labOrderForm.reset();
        },
        (error) => {
          this.data = null;
          this.message = error.message;
          console.error('Error voiding order: ' + error.message);
          alert('Error voiding labOrder. ' + error.message);
        }
      );
  }

  public completeOrder(): string {
    console.log('Complete order request received for: ' + this.labOrderForm.value.labOrderNumber);
    console.log('Assign Invoice Number: ' + this.labOrderForm.value.labInvoiceNumber);

    const labOrderNumber: string = this.labOrderForm.value.labOrderNumber;
    const labInvoiceNumber: string = this.labOrderForm.value.labInvoiceNumber;

    // if invoice number is specified, let's make sure it's not more than 11 chars.
    if (labInvoiceNumber && labInvoiceNumber.length > 11) {
      alert('Invoice number should be 11 characters or less.');
      return;
    }

    this.subs.add = this.labOrderBusinessService.completeLabOrder(labOrderNumber, labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          const message = 'Successfully completed laborder: ' + labOrder.labOrderNumber;
          console.log(message);
          this.data = labOrder;
          this.message = message;
          this.labOrderForm.reset();
        },
        (error) => {
          this.data = null;
          this.message =  error.message;
          console.error('Error completing order: ' + error.message);
          alert('Error completing labOrder. ' + error.message);
        }
      );
    return this.data;
  }

  // Modify the Lab Order
  public modifyOrder(): string {
    console.log('Complete order request received for: ' + this.labOrderForm.value.labOrderNumber);

    const labOrderNumber: string = this.labOrderForm.value.labOrderNumber;
    const labInvoiceNumber = this.labOrderForm.value.labInvoiceNumber;

    this.subs.add = this.labOrderBusinessService.viewLabOrder(labOrderNumber)
      .subscribe(
        (labOrder) => {
          if (UtilsService.isPrivateOrder(labOrder) || UtilsService.isAPIOrder(labOrder)) {
            this.router.navigate(['modifyOrder/', labOrderNumber], {queryParams: {'labInvoiceNumber': labInvoiceNumber}});
          } else {
            this.data = null;
            // inform user that order is not available for update
            this.message = Messages.LEGACY_VSP_ORDER_NOT_UPDATABLE_MESSAGE;
            this.labOrderForm.reset();
            console.error('Error modifying order: ' + this.message);
            alert('Error modifying order: ' + this.message);
          }
        },
        (error) => {
          this.data = null;
          this.message =  error.message;
          console.error('Error modifying order: ' + error.message);
          alert('Error modifying labOrder. ' + error.message);
        }
      );


    return this.data;
  }

  public submitModal(input) {
    console.log('submitModal: ', input);
    const action = input.action;
    this.labOrderForm.value.labInvoiceNumber = input.invoiceNumber;

    switch (action) {
      case 'ACCEPT' : this.acceptOrder(); break;
      case 'VIEW' : this.viewOrder(); break;
      case 'ASSIGN' : this.assignInvoiceNumber(); break;
      case 'COMPLETE' : this.completeOrder(); break;
      case 'MODIFY' : this.modifyOrder(); break;
      case 'VOID' : this.voidOrder(); break;

      default : console.log('Unknown submission.'); break;
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/orders/orders.component.ts